import { render, staticRenderFns } from "./LinkWithApisTickets.vue?vue&type=template&id=1f333f6c&scoped=true"
import script from "./LinkWithApisTickets.vue?vue&type=script&lang=js"
export * from "./LinkWithApisTickets.vue?vue&type=script&lang=js"
import style0 from "./LinkWithApisTickets.vue?vue&type=style&index=0&id=1f333f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f333f6c",
  null
  
)

export default component.exports